import { Alert, type AlertProps } from "@mui/material";
import Box from "@mui/material/Box";
import { BodyTextM } from "@repo/ui";
import { type FC } from "react";

const Attention: FC<AlertProps> = ({ title, action, children, ...rest }) => {
    return (
        <Alert {...rest}>
            {title && (
                <BodyTextM strong sx={{ display: "inline-block", mb: 2 }}>
                    {title}
                </BodyTextM>
            )}
            <Box>
                <BodyTextM>{children}</BodyTextM>
            </Box>
            {action && <Box sx={{ mt: 2 }}>{action}</Box>}
        </Alert>
    );
};

export default Attention;
